import { useCallback } from 'react';
import { isSome } from 'fp-ts/Option';
import { useDashboard } from 'adapter/in/dashboards/context/Dashboard';
import Dashboard from 'domain/entity/dashboard';
import { UpdateDashboardNameCriteriaBuilder } from 'use-case/dashboard/update/updateDashboardCriteria/updateDashboardNameCriteria';
import { UpdateDashboardAccessCriteriaBuilder } from 'use-case/dashboard/update/updateDashboardCriteria/updateDashboardAccessCriteria';

type UseUpdateDashboard = {
    update: (updatedDashboard: Dashboard) => void;
    isLoading: boolean;
    data: Dashboard | null;
    success: boolean;
    error: boolean;
    reset: () => void;
};

export const useUpdateNameDashboard = (): UseUpdateDashboard => {
    const { updateNameError, updateNameResult, updateNameIsLoading, updateName, updateNameReset } = useDashboard();
    const handleUpdate = useCallback(
        (updatedDashboard: Dashboard) =>
            updateName(UpdateDashboardNameCriteriaBuilder.create().withId(updatedDashboard.id).withName(updatedDashboard.name).build()),
        []
    );

    return {
        update: handleUpdate,
        isLoading: updateNameIsLoading,
        data: isSome(updateNameResult) ? updateNameResult.value : null,
        success: !!isSome(updateNameResult),
        error: !!isSome(updateNameError),
        reset: updateNameReset,
    };
};

export const useUpdateAccessDashboard = (): UseUpdateDashboard => {
    const { updateAccessError, updateAccessResult, updateAccessIsLoading, updateAccess, updateAccessReset } = useDashboard();
    const handleUpdate = useCallback(
        (updatedDashboard: Dashboard) =>
            updateAccess(
                UpdateDashboardAccessCriteriaBuilder.create().withId(updatedDashboard.id).withAccess(updatedDashboard.access).build()
            ),
        []
    );

    return {
        update: handleUpdate,
        isLoading: updateAccessIsLoading,
        data: isSome(updateAccessResult) ? updateAccessResult.value : null,
        success: !!isSome(updateAccessResult),
        error: !!isSome(updateAccessError),
        reset: updateAccessReset,
    };
};
